import { Promotion } from "@/_models/promotion.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-promotion-task-card",
    standalone: true,
    imports: [SharedComponentsModule, CombinedTaskCardMobileComponent],
    templateUrl: "./promotion-task-card.component.html",
    styleUrls: [
        "./promotion-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class PromotionTaskCardComponent implements OnInit {
    @Input() promotion: Promotion;
    @Input() showEdit: boolean = false;

    constructor(public dateUtils: DateUtils) {}

    ngOnInit() {}
}
